import { Container } from "./styles";
import AbaDeDemandas, { IAbaDeDenanda } from "../AbaDeDemandas";

export default function GrupoDeAbasDeDemandas({
    dadosAbas,
    filtraPorStatus,
    abaAtiva,
    setAbaAtiva,
    loading = false
}: {
    dadosAbas: IAbaDeDenanda[];
    filtraPorStatus: (status: string[]) => void;
    abaAtiva: number;
    setAbaAtiva: (aba: number) => void;
    loading?: boolean;
}) {

    function selecionaAba(aba: IAbaDeDenanda) {
        setAbaAtiva(aba.id);
        filtraPorStatus(aba.status);
    }


  return <Container>
    {dadosAbas && dadosAbas.map((aba, index) => (
        <AbaDeDemandas 
            key={aba.id} 
            dadosAba={aba}
            selecionaAba={selecionaAba}
            abaAtiva={abaAtiva === aba.id}
            isFirst={index === 0}
            isLast={index === dadosAbas.length - 1}
            loading={loading}
        />
    ))}
  </Container>;
}